<template>
  <el-dialog class="modal-v2 no-title" :visible.sync="showDialog" :close-on-click-modal="false" width="1055px" append-to-body>
    <div class="flex vertical">
      <div class="paid-top-container relative w100 flex vertical center">
        <i class="el-icon-close font-16 color-white pointer" @click="close"></i>
        <span class="font-30 fw-600 mb30">该功能为付费功能，需支付费用获得相应权限</span>
        <span class="font-16 mb10">薪税云四上企业报表功能，帮助企业轻松完成国家统计局要求的年度、季度数据申报。</span>
        <span class="font-16">人员薪资数据智能能汇总，统计报表一键填报，大幅提高数据统计工作的效率和准确性。</span>
      </div>

      <div class="paid-bottom-container w100 flex vertical">
        <div class="relative flex center mt40">
          <span class="font-18 fw-600 color-1c">付费后您可以获得的权限与功能：</span>
          <div class="flex acenter" style="position: absolute; right: 73px;">
            <img src="@/assets/img/v2/common/kefu.png" class="size16 mr10" />
            <span class="font-16 color-primary-v2">业务咨询</span>
          </div>
        </div>
        <div class="w100 flex jevenly acenter mt42">
          <div v-for="item in features" class="flex vertical center">
            <img :src="require(`@/assets/img/v2/sishang/${item}.png`)" class="size76 mb12" />
            <span class="font-16 color-3">{{ item }}</span>
          </div>
        </div>
        <div class="flex center">
          <el-button type="primary" class="button-v2 mt60" @click="close">我知道了</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PaidModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      features: ['内置多种模版', '模版自动更新', '智能获取员工信息', '在线生成统计报表']
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.paid-top-container {
  height: 222px;
  background: url('~@/assets/img/v2/sishang/付款弹窗背景.png') no-repeat;
  background-size: 100% 222px;

  .el-icon-close {
    position: absolute;
    top: 23px;
    right: 35px;
  }
  span {
    color: #FFFFFF;
  }
}
.paid-bottom-container {
  height: 338px;
}
</style>
